export const cardTypes = Object.freeze({
  amex: 'American Express',
  diners: 'Diners',
  discover: 'Discover',
  mastercard: 'Mastercard',
  visa: 'Visa',
})

export const subStatuses = Object.freeze({
  active: {
    display: 'Active',
    hasIssue: false,
  },
  canceled: {
    display: 'Canceled',
    hasIssue: true,
  },
  incomplete: {
    display: 'On Hold',
    hasIssue: true,
  },
  incomplete_expired: {
    display: 'On Hold',
    hasIssue: true,
  },
  past_due: {
    display: 'On Hold',
    hasIssue: true,
  },
  trialing: {
    display: 'On Trial',
    hasIssue: false,
  },
  unpaid: {
    display: 'On Hold',
    hasIssue: true,
  },
})

export const hasBillingIssue = function (subStatus) {
  const status = subStatuses[subStatus]

  if (status) {
    return status.hasIssue
  } else {
    return false
  }
}

export const allowBillingUpdatesForStatus = function (subStatus) {
  const status = subStatuses[subStatus]

  if (status) {
    return true
  } else {
    return false
  }
}
